"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const compare_1 = require("../helper/compare");
const DownloadTile_1 = __importDefault(require("./DownloadTile"));
const LinkTile_1 = __importDefault(require("./LinkTile"));
class SoftwareDownloadsTabs extends react_1.default.Component {
    tabActive = 0;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            tabActive: mobx_1.observable,
            updateTabActive: mobx_1.action.bound,
        });
    }
    render() {
        const { software, categories } = this.props;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("nav", { className: "znd-tabs znd-software-downloads-tabs znd-tabs--small" },
                react_1.default.createElement("div", { className: "znd-software-downloads-tabs__wrapper" }, categories.map((category, index) => (react_1.default.createElement("div", { className: "znd-tabs__item-wrapper", key: category.key, onClick: () => {
                        this.updateTabActive(index);
                    } },
                    react_1.default.createElement("span", { className: (0, classnames_1.default)('znd-tabs__item znd-software-downloads-tabs__item', {
                            'znd-tabs__item--active znd-software-downloads-tabs__item--active': this.tabActive == index,
                        }) }, category.name)))))),
            categories.map((category, index) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-software-downloads', {
                    'znd-software-downloads--active': this.tabActive == index,
                }), key: category.key },
                react_1.default.createElement("div", { className: "znd-software-downloads__title t-headline-3" }, category.name),
                react_1.default.createElement("div", { className: "row" }, this.renderTiles(software, category)))))));
    }
    updateTabActive(index) {
        this.tabActive = index;
    }
    renderTiles(software, category) {
        const files = category.files?.map((file) => {
            return {
                name: file.name,
                element: react_1.default.createElement(DownloadTile_1.default, { software: software, category: category.key, file: file, key: file.key }),
            };
        });
        const urls = category.urls?.map((url) => {
            return {
                name: url.name,
                element: react_1.default.createElement(LinkTile_1.default, { link: url, key: Math.random() }),
            };
        });
        return [...(files ?? []), ...(urls ?? [])]
            .sort((a, b) => (0, compare_1.naturalCompare)(a.name, b.name))
            .map((item) => item.element);
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(SoftwareDownloadsTabs));
